import type { FC, ReactNode } from 'react';

import makeStyles from '@mui/styles/makeStyles';
import { SnackbarProvider as NotistackSnackbarProvider } from 'notistack';

import { theme } from 'shared/theme';

const useSnackbarStyles = makeStyles(() => ({
  root: {
    '& .SnackbarContent-root': {
      minWidth: 'auto',
      [theme.breakpoints.up('sm')]: {
        minWidth: 'auto',
      },
    },
  },
}));

export const SnackbarProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const classes = useSnackbarStyles();

  return (
    <NotistackSnackbarProvider
      dense
      anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
      classes={classes}
      maxSnack={3}
    >
      {children}
    </NotistackSnackbarProvider>
  );
};
